import { event } from '../content/event';
import { trackEvent } from '../services/analytics';

function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero__copy">
        <p className="eyebrow">{event.edition}th Annual</p>
        <h1 id="hero-title">{event.title}</h1>
        <p className="hero__theme">{event.theme}</p>
        <div className="hero__when" aria-label={`${event.displayDate} at ${event.displayTime}`}>
          <span>{event.displayDate}</span><span>{event.displayTime}</span>
        </div>
        <div className="hero__actions">
          <a className="button" href="#rsvp" onClick={() => trackEvent('rsvp_cta_clicked')}>RSVP now <span aria-hidden="true">→</span></a>
          <a className="text-link" href="#story">Read the turkey story <span aria-hidden="true">↓</span></a>
        </div>
      </div>
      <figure className="hero__art">
        <img
          src="/hero-parade-v3-1536.jpg"
          srcSet="/hero-parade-v3-900.jpg 900w, /hero-parade-v3-1536.jpg 1536w"
          sizes="(max-width: 900px) 88vw, 55vw"
          width="1536"
          height="1024"
          alt="Three dogs running ahead of a joyful giant turkey float in an autumn parade"
          fetchpriority="high"
        />
        <figcaption>Same turkey. Different legend.</figcaption>
      </figure>
    </section>
  );
}

export default Hero;
